import { jsxs as o, jsx as e, Fragment as v } from "react/jsx-runtime";
import { X as N } from "lucide-react";
import { forwardRef as C } from "react";
import { c as n } from "./cn-DlLpp5ix.js";
import { F as b } from "./focus-BJKdC9pu.js";
const S = {
  xs: "h-6 px-2 text-2xs gap-1",
  sm: "h-7 px-2.5 text-2xs gap-1.5",
  md: "h-8 px-3 text-xs gap-2"
}, E = {
  neutral: "bg-bg-elevated text-secondary border-default",
  accent: "bg-accent-dim text-secondary border-accent-border",
  success: "bg-success-bg text-secondary border-success-border",
  warning: "bg-warning-bg text-secondary border-warning-border",
  error: "bg-error-bg text-secondary border-error-border",
  info: "bg-info-bg text-secondary border-info-border",
  purple: "bg-purple-bg text-secondary border-purple-border",
  magenta: "bg-magenta-bg text-secondary border-magenta-border",
  orange: "bg-orange-bg text-secondary border-orange-border"
}, F = {
  neutral: "bg-bg-hover text-primary border-strong",
  accent: "bg-accent-dim text-primary border-accent",
  success: "bg-success-bg text-success border-success",
  warning: "bg-warning-bg text-warning border-warning",
  error: "bg-error-bg text-error border-error",
  info: "bg-info-bg text-info border-info",
  purple: "bg-purple-bg text-purple border-purple",
  magenta: "bg-magenta-bg text-magenta border-magenta",
  orange: "bg-orange-bg text-orange border-orange"
}, _ = C(
  function(l, g) {
    const {
      children: p,
      selected: t = !1,
      icon: s,
      value: i,
      onRemove: d,
      removeAriaLabel: m,
      size: c = "sm",
      tone: a = "neutral",
      className: u,
      disabled: r = !1,
      type: x,
      ...f
    } = l, h = S[c], y = t ? F[a] : E[a];
    return /* @__PURE__ */ o(
      "span",
      {
        "data-selected": t || void 0,
        "data-tone": a,
        "data-size": c,
        className: n(
          "inline-flex items-center rounded-pill border whitespace-nowrap",
          "font-medium transition-colors duration-fast ease-out",
          h,
          y,
          r && "opacity-60 cursor-not-allowed",
          u
        ),
        children: [
          /* @__PURE__ */ o(
            "button",
            {
              ref: g,
              type: x ?? "button",
              role: "switch",
              "aria-checked": t,
              "aria-disabled": r || void 0,
              disabled: r,
              className: n(
                "inline-flex items-center gap-1.5 outline-none bg-transparent text-current",
                b,
                "rounded-pill -mx-1 px-1"
              ),
              ...f,
              children: [
                s !== void 0 && /* @__PURE__ */ e("span", { className: "inline-flex items-center", "aria-hidden": "true", children: s }),
                /* @__PURE__ */ e("span", { children: p }),
                i !== void 0 && /* @__PURE__ */ o(v, { children: [
                  /* @__PURE__ */ e("span", { "aria-hidden": "true", className: "opacity-60", children: ":" }),
                  /* @__PURE__ */ e("span", { className: "font-semibold", children: i })
                ] })
              ]
            }
          ),
          d && /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: (w) => {
                w.stopPropagation(), r || d();
              },
              "aria-label": m ?? "Remove",
              disabled: r,
              className: n(
                "ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full",
                "text-secondary hover:text-primary hover:bg-bg-hover",
                "disabled:cursor-not-allowed disabled:opacity-60",
                b
              ),
              children: /* @__PURE__ */ e(N, { className: "w-3 h-3", "aria-hidden": "true" })
            }
          )
        ]
      }
    );
  }
);
_.displayName = "FilterChip";
export {
  _ as F
};
//# sourceMappingURL=FilterChip-CWAMqAnU.js.map
